import useStrings from "../../localization/useStrings"
import native from "../../native/native"
import { isPromo } from "../../utils/utils"
import FeatureList from "../FeatureList/FeatureList"
import Terms from "../Terms/Terms"
import styles from "./FeatureTermsList.module.scss"

const FeatureTermsList = () => {
  const showSpacer = isPromo()

  return (
    <div className={styles.container}>
      <FeatureList />
      {showSpacer && <div className={styles.spacer} />}
      <Terms />
    </div>
  )
}

export default FeatureTermsList
